import React from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineShareAltIcon from 'components/Luxkit/Icons/line/LineShareAltIcon'
import { useTranslation } from 'react-i18next'

interface Props extends Omit<React.ComponentProps<typeof TextButton>, 'kind' | 'children'> {}

function ShareWithFriendsButton(props: Props) {
  const { t } = useTranslation('common')

  return <TextButton
    kind="tertiary"
    {...props}
    startIcon={<LineShareAltIcon aria-hidden="true" />}
  >
    {t('Share', { ns: 'common' })}
  </TextButton>
}

export default ShareWithFriendsButton
